import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-success-rate-widget',
  standalone: true,
  imports: [CommonModule, CardModule, ProgressBarModule, SkeletonModule],
  templateUrl: './success-rate-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SuccessRateWidget {
  @Input() completedRuns: number = 0;
  @Input() failedRuns: number = 0;
  @Input() loading: boolean = false;

  getSuccessRate(): number {
    const total = this.completedRuns + this.failedRuns;
    if (total === 0) return 0;
    return Math.round((this.completedRuns / total) * 100);
  }
}
